var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { staticClass: "vs-root" },
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("standard-search-fields")))]),
      _c(
        "w-card-content",
        { staticClass: "vs-content" },
        [
          _vm._l(_vm.columns, function (column, i) {
            return _c("div", { key: i, staticClass: "vs-row" }, [
              _c("span", { staticClass: "vs-name" }, [
                _vm._v(_vm._s(_vm.$t(_vm.getFriendlyName(column)))),
              ]),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: _vm.$ct("remove-field"),
                      expression: "$ct('remove-field')",
                    },
                  ],
                  staticClass: "vs-ib del",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.removeColumn(i)
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "trash" } })],
                1
              ),
            ])
          }),
          _vm.columns.length == 0
            ? _c("div", { staticClass: "vs-empty" }, [
                _vm._v(_vm._s(_vm.$ct("no-search-fields"))),
              ])
            : _vm._e(),
          _c(
            "button",
            {
              staticClass: "vs-add",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  _vm.addModal = true
                },
              },
            },
            [
              _c("w-fa", { attrs: { icon: "plus" } }),
              _vm._v(_vm._s(_vm.$ct("column-add")) + " "),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "w-modal",
        {
          model: {
            value: _vm.addModal,
            callback: function ($$v) {
              _vm.addModal = $$v
            },
            expression: "addModal",
          },
        },
        [
          _vm.addModal
            ? _c("app-search-settings-add-column-modal", {
                attrs: { "selected-columns": _vm.columns, model: _vm.model },
                on: {
                  close: function ($event) {
                    _vm.addModal = false
                  },
                  save: _vm.save,
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }